var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVietnamFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 22C17.5228 22 21.9999 17.5228 21.9999 12C21.9999 6.47715 17.5228 2 11.9999 2C6.47709 2 1.99994 6.47715 1.99994 12C1.99994 17.5228 6.47709 22 11.9999 22Z",
    fill: "#D32F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5274 12.7968L15.9999 10.9998H12.9454L11.9999 8.09375L11.0544 10.9998H7.99994L10.4724 12.7968L9.52694 15.7032L11.9999 13.9062L14.4724 15.7032L13.5274 12.7968Z",
    fill: "#FFEB3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVietnamFlag);
export default __webpack_public_path__ + "static/media/vietnam_flag.a7ed46bb1f46db9ab2ed6d6afa8c9d4d.svg";
export { ForwardRef as ReactComponent };